<template>
  <!-- 资金安全 · 充值到账四步流程（原信息图的 HTML/CSS 复刻） -->
  <div class="deposit-flow">
    <div class="deposit-track">
      <article class="deposit-step">
        <h5 class="deposit-title">{{ $t("fundSafety.d3S1Title") }}</h5>
        <p class="deposit-text">{{ $t("fundSafety.d3S1Text") }}</p>
        <p class="deposit-note deposit-note--warn">
          <span class="deposit-emoji">⚠️</span>
          <span>{{ $t("fundSafety.d3S1Note") }}</span>
        </p>
      </article>

      <span class="deposit-arrow" aria-hidden="true"></span>

      <article class="deposit-step deposit-step--cyan">
        <h5 class="deposit-title">{{ $t("fundSafety.d3S2Title") }}</h5>
        <p class="deposit-text">{{ $t("fundSafety.d3S2Text") }}</p>
        <p class="deposit-note">
          <span>{{ $t("fundSafety.d3S2Note") }}</span>
        </p>
      </article>

      <span class="deposit-arrow" aria-hidden="true"></span>

      <article class="deposit-step">
        <h5 class="deposit-title">{{ $t("fundSafety.d3S3Title") }}</h5>
        <p class="deposit-text">{{ $t("fundSafety.d3S3Text") }}</p>
        <p class="deposit-note deposit-note--ok">
          <span class="deposit-emoji">✅</span>
          <span>{{ $t("fundSafety.d3S3Note") }}</span>
        </p>
      </article>

      <span class="deposit-arrow deposit-arrow--success" aria-hidden="true"></span>

      <article class="deposit-step deposit-step--done">
        <h5 class="deposit-title">{{ $t("fundSafety.d3S4Title") }}</h5>
        <p class="deposit-text">{{ $t("fundSafety.d3S4Text") }}</p>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "FundDepositFlow",
};
</script>

<style scoped>
.deposit-flow {
  padding: 22px 24px;
  border-radius: 16px;
  border: 1px solid rgba(0, 180, 255, 0.14);
  background: radial-gradient(
      120% 140% at 20% 0%,
      rgba(0, 180, 255, 0.12),
      transparent 58%
    ),
    linear-gradient(180deg, #0a1727 0%, #070d17 100%);
  box-shadow: 0 24px 48px -34px rgba(0, 0, 0, 0.95);
}

.deposit-track {
  display: flex;
  align-items: stretch;
}

.deposit-step {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 14px;
  border-radius: 10px;
  border: 1px solid rgba(59, 130, 246, 0.55);
  background: linear-gradient(
    180deg,
    rgba(8, 30, 54, 0.9),
    rgba(5, 12, 22, 0.92)
  );
  text-align: center;
}

.deposit-step--cyan {
  border-color: rgba(34, 211, 238, 0.55);
}

.deposit-step--done {
  border-color: rgba(34, 197, 94, 0.55);
  background: linear-gradient(
    135deg,
    rgba(6, 95, 70, 0.6),
    rgba(3, 40, 38, 0.8)
  );
  box-shadow: 0 16px 34px -26px rgba(34, 197, 94, 0.95);
}

.deposit-title {
  margin: 0;
  font-size: 13.5px;
  font-weight: 700;
  line-height: 1.45;
  color: #38bdf8;
}

.deposit-step--cyan .deposit-title {
  color: #22d3ee;
}

.deposit-step--done .deposit-title {
  color: #4ade80;
}

.deposit-text {
  margin: 0;
  font-size: 11.5px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.6);
}

.deposit-step--done .deposit-text {
  font-weight: 600;
  color: rgba(220, 252, 231, 0.85);
}

.deposit-note {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 5px;
  margin: 2px 0 0;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.62);
}

.deposit-note--warn {
  color: #f87171;
}

.deposit-note--ok {
  color: #4ade80;
}

.deposit-emoji {
  flex: 0 0 auto;
  line-height: inherit;
}

/* 连接箭头：默认蓝色实线，--success 为绿色虚线 */
.deposit-arrow {
  --line-color: #1d9bf0;
  position: relative;
  flex: 0 0 34px;
  height: 2px;
  align-self: center;
  margin: 0 6px;
  background: var(--line-color);
}

.deposit-arrow--success {
  --line-color: #22c55e;
  background: none;
  background-image: repeating-linear-gradient(
    90deg,
    var(--line-color) 0 6px,
    transparent 6px 11px
  );
}

.deposit-arrow::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -1px;
  transform: translateY(-50%);
  border-left: 7px solid var(--line-color);
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
}

@media (max-width: 1100px) {
  .deposit-flow {
    padding: 18px 16px;
  }

  .deposit-track {
    flex-direction: column;
  }

  .deposit-arrow {
    flex: 0 0 22px;
    width: 2px;
    height: 22px;
    margin: 4px auto;
  }

  .deposit-arrow--success {
    background-image: repeating-linear-gradient(
      180deg,
      var(--line-color) 0 6px,
      transparent 6px 11px
    );
  }

  .deposit-arrow::after {
    top: auto;
    bottom: -1px;
    right: auto;
    left: 50%;
    transform: translateX(-50%);
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 7px solid var(--line-color);
    border-bottom: 0;
  }
}
</style>
